import Modal from "./Modal";
import successIcon from "assets/icons/success.svg";
import error from "assets/icons/error.svg";
import Card from "components/Card/Card";
import styles from "./Modal.module.scss";

interface StatusModalProps {
  success?: boolean;
  text: string;
}

function StatusModal({ success, text }: StatusModalProps) {
  return (
    <Modal onClose={() => {}}>
      <Card className={styles.statusModal}>
        <img src={success ? successIcon : error} alt="" />
        {success ? <h4>Success!</h4> : <h4>Error!</h4>}
        <p>{text}</p>
        {/* <Button
          text={success ? "Continue" : "Try Again"}
          color="dark"
          onClick={() => {
            dispatch(setBuyState("buy"));
            dispatch(setValidatedCustomer(false));
            dispatch(setElectricityState("buy"));
          }}
        /> */}
      </Card>
    </Modal>
  );
}

export default StatusModal;
